import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle, Loader } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n";

export default function BookingReturn() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("pending");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setState("failed"); return; }
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (data.status === "expired") { setState("failed"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="max-w-md w-full border border-white/10 bg-[#141414] p-12 text-center" data-testid="booking-return">
        {state === "pending" && (<><Loader className="mx-auto text-[#BC5D2E] animate-spin" size={40} /><p className="font-clash text-2xl uppercase tracking-tight mt-6">{t("payment_pending")}</p></>)}
        {state === "success" && (
          <>
            <CheckCircle className="mx-auto text-[#BC5D2E]" size={48} />
            <p className="font-clash text-3xl uppercase tracking-tight mt-6 text-[#BC5D2E]">{t("payment_success")}</p>
            {info && <p className="text-[#A3A3A3] mt-3">{info.expedition_title} · {info.amount?.toLocaleString()} {info.currency?.toUpperCase()}</p>}
            <p className="font-mono-hs text-xs text-[#737373] mt-4 uppercase tracking-widest">Votre place est réservée. Nous vous contactons.</p>
          </>
        )}
        {state === "failed" && (<><XCircle className="mx-auto text-[#8A281E]" size={48} /><p className="font-clash text-2xl uppercase tracking-tight mt-6">{t("payment_failed")}</p></>)}
        <Link to="/" className="inline-block mt-8 border border-white/30 px-8 py-3 uppercase tracking-widest text-xs hover:border-white transition-colors">{t("back_home")}</Link>
      </div>
    </div>
  );
}
